// import $ from 'jquery';
import 'owl.carousel/dist/assets/owl.carousel.css!';
import 'owl.carousel';

class HomeSlider {

  constructor(){
    const $ = jQuery;
    this.slider = $("[data-trigger='blocks-slider']");
    this._init();
  }

  _init(){
    
    document.addEventListener('DOMContentLoaded', (event) => {

      if( this.slider[0] ){
        
        this.slider.owlCarousel({
          items                : 1,
          nav                  : true,
          navText              : ['',''],
          dots                 : false,
          // autoplay          : false,
          // autoplayTimeout   : 5000,
          // autoplayHoverPause: false,
          // autoHeight         : true,
        });

      };  

    });
  }

}

export const homeSlider = new HomeSlider();